function page(path) {
  return () => import(/* webpackChunkName: '' */ `~/views/${path}`).then((m) => m.default || m);
}
export default [
{
  path: '/login',
  name: 'login',
  component: page('auth/login.vue'),
  props: true,
},
// { path: '/register', name: 'register', component: page('auth/register.vue') },
{
  path: '/password/reset',
  name: 'password.request',
  component: page('auth/password/email.vue'),
},
{
  path: '/password/reset/:token',
  name: 'password.reset',
  component: page('auth/password/reset.vue'),
},
{
  path: '/email/verify/:id',
  name: 'verification.verify',
  component: page('auth/verification/verify.vue'),
},
{
  path: '/email/resend',
  name: 'verification.resend',
  component: page('auth/verification/resend.vue'),
},
{
  path: '/home',
  name: 'home',
  component: page('indicator.vue'),
},
{
  path: '/settings',
  component: page('settings/index.vue'),
  children: [{
      path: '',
      redirect: {
        name: 'settings.profile',
      },
    },
    {
      path: 'profile',
      name: 'settings.profile',
      component: page('settings/profile.vue'),
    },
    {
      path: 'password',
      name: 'settings.password',
      component: page('settings/password.vue'),
    },
    {
      path: 'profileEnterprise',
      name: 'settings.profileEnterprise',
      component: page('settings/profileEnterprise.vue'),
    },
  ],
},
{
  path: '/reportes/reportes_documentos',
  name: 'reportDocuments',
  component: page('reports/documents/index.vue'),
  props: true,
},
{
  path: '/reportes/reportes_numeraciones',
  name: 'reportNumerations',
  component: page('reports/numerations/index.vue'),
  props: true,
},
{
  path: '/reportes/reportes_ventas',
  name: 'reportSales',
  component: page('reports/sales/index.vue'),
  props: true,
},
{
  path: '/reportes/intentos_fallidos',
  name: 'reportRejected',
  component: page('reports/logs/index.vue'),
  props: true,
},
{
  path: '/reportes/reportes_emitidos',
  name: 'reportIssued',
  component: page('reports/issued/index.vue'),
  props: true,
},
{
  path: '/reportes/reporte_seniat',
  name: 'reportTotals',
  component: page('reports/document_totals/index.vue'),
  props: true,
},
{
  path: '/reportes/reporte_seniat_numeraciones',
  name: 'reportTotalsNumerations',
  component: page('reports/document_totals/weekly.vue'),
  props: true,
},
{
  path: '/reportes/reportes_asignaciones',
  name: 'assignmentReport',
  component: page('reports/assignments/index.vue'),
  props: true,
},
{
  path: '/reportes/reportes_articulo',
  name: 'artReport',
  component: page('reports/articulo/index.vue'),
  props: true,
},
{
  path: '/usuarios',
  name: 'users',
  component: page('users/index.vue'),
  props: true,
},
{
  path: '/usuarios/agregar',
  name: 'createUser',
  component: page('users/create.vue'),
  props: true,
},
{
  path: '/usuarios/editar',
  name: 'editUser',
  component: page('users/create.vue'),
  props: true,
},
{
  path: '/usuarios/store',
  name: 'storeUser',
  component: page('users/store.vue'),
},
{
  path: '/catalogos/distribuidores',
  name: 'dealers',
  component: page('catalogs/dealers/index.vue'),
  props: true,
},
{
  path: '/catalogos/distribuidores/agregar',
  name: 'createDealers',
  component: page('catalogs/dealers/create.vue'),
  props: true,
},
{
  path: '/catalogos/distribuidores/:dealerId',
  component: page('catalogs/dealers/profile.vue'),
  props: true,
  children: [
    {
      path: '',
      redirect: {
        name: 'dealer.profileDealer',
      },
    },
    {
      path: 'perfil',
      name: 'dealer.profileDealer',
      component: page('catalogs/dealers/create.vue'),
      props: true,
    },
    {
      path: 'usuarios',
      name: 'dealer.usersDealer',
      component: page('catalogs/dealers/users/index.vue'),
      props: true,
    },
    {
      path: 'usuarios/agregar',
      name: 'createdealerUsers',
      component: page('catalogs/dealers/users/create.vue'),
      props: true,
    },
    {
      path: 'usuarios/:userId/editar',
      name: 'editdealerUsers',
      component: page('catalogs/dealers/users/create.vue'),
      props: true,
    },
    {
      path: 'empresas',
      name: 'dealer.enterprises',
      component: page('catalogs/dealers/enterprises.vue'),
      props: true,
    },
    {
      path: 'empresas/agregar',
      name: 'dealer.enterprises.add',
      component: page('catalogs/dealers/enterpriseAssociation.vue'),
      props: true,
    },
    {
      path: 'licencias',
      name: 'dealer.services',
      component: page('catalogs/dealers/services.vue'),
      props: true,
    },
    {
      path: 'licencias/:id_licencia',
      name: 'dealer.licence',
      component: page('catalogs/dealers/licences.vue'),
      props: true,
    },
  ],
},
{
  path: '/catalogos/distribuidores/:dealerId/empresas/agregar',
  name: 'dealer.enterprise.add',
  component: page('catalogs/dealers/enterpriseAssociation.vue'),
  props: true,
},
{
  path: '/catalogos/distribuidores/:dealerId/empresas/:enterpriseId',
  component: page('enterprises/list/profile.vue'),
  props: true,
  children: [
    {
      path: '',
      redirect: {
        name: 'dealers.enterprise.profileEnterprise',
      },
    },
    {
      path: 'perfil',
      name: 'dealers.enterprise.profileEnterprise',
      component: page('enterprises/list/create.vue'),
      props: true,
    },
    {
      path: 'licencias',
      name: 'dealers.enterprise.licences',
      component: page('enterprises/licences/index.vue'),
      props: true,
    },
    {
      path: 'sucursales',
      name: 'dealers.enterprise.subsidiaries',
      component: page('enterprises/subsidiary/index.vue'),
      props: true,
    },
    {
      path: 'sucursales/agregar',
      name: 'dealers.enterprise.subsidiaries.create',
      component: page('enterprises/subsidiary/create.vue'),
      props: true,
    },
    {
      path: 'sucursales/:id/editar',
      name: 'dealers.enterprise.subsidiaries.edit',
      component: page('enterprises/subsidiary/create.vue'),
      props: true,
    },
    {
      path: 'sucursales/:id/punto',
      name: 'dealers.enterprise.subsidiaries.point',
      component: page('enterprises/subsidiary/point.vue'),
      props: true,
    },
    {
      path: 'sucursales/:id/punto/:pointId/editar',
      name: 'dealers.enterprise.subsidiaries.point.edit',
      component: page('enterprises/subsidiary/createPoint.vue'),
      props: true,
    },
    {
      path: 'usuarios',
      name: 'dealers.enterprise.users',
      component: page('enterprises/users/index.vue'),
      props: true,
    },
    {
      path: 'usuarios/agregar',
      name: 'dealers.enterprise.users.create',
      component: page('enterprises/users/create.vue'),
      props: true,
    },
    {
      path: 'usuarios/:id/:type/editar',
      name: 'dealers.enterprise.users.edit',
      component: page('enterprises/users/create.vue'),
      props: true,
    },
    {
      path: 'integracion',
      name: 'dealers.enterprise.integration',
      component: page('enterprises/integration/index.vue'),
      props: true,
    },
    {
      path: 'integracion/agregar',
      name: 'dealers.enterprise.integration.create',
      component: page('enterprises/integration/create.vue'),
      props: true,
    },
    {
      path: 'integracion/:id/editar',
      name: 'dealers.enterprise.integration.edit',
      component: page('enterprises/integration/create.vue'),
      props: true,
    },
    {
      path: 'numeration',
      name: 'dealers.enterprise.numeration',
      component: page('enterprises/numeration/index.vue'),
      props: true,
    },
    {
      path: 'numeration/agregar',
      name: 'dealers.enterprise.numeration.create',
      component: page('enterprises/numeration/create.vue'),
      props: true,
    },
    {
      path: 'numeration/:serieId/editar',
      name: 'dealers.enterprise.numeration.edit',
      component: page('enterprises/numeration/create.vue'),
      props: true,
    },
    {
      path: 'numeration/autoregistro',
      name: 'dealers.enterprise.numeration.auto',
      component: page('enterprises/numeration/automatic.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll',
      name: 'dealers.enterprise.numeration_payroll',
      component: page('enterprises/numeration_payroll/index.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll/agregar',
      name: 'dealers.enterprise.numeration_payroll.create',
      component: page('enterprises/numeration_payroll/create.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll/:serieId/editar',
      name: 'dealers.enterprise.numeration_payroll.edit',
      component: page('enterprises/numeration_payroll/create.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll/autoregistro',
      name: 'dealers.enterprise.numeration_payroll.auto',
      component: page('enterprises/numeration_payroll/automatic.vue'),
      props: true,
    },
    {
      path: 'server',
      name: 'dealers.enterprise.server',
      component: page('enterprises/server/index.vue'),
      props: true,
    },
    {
      path: 'server/agregar',
      name: 'dealers.enterprise.server.create',
      component: page('enterprises/server/create.vue'),
      props: true,
    },
    {
      path: 'server/:id/editar',
      name: 'dealers.enterprise.server.edit',
      component: page('enterprises/server/create.vue'),
      props: true,
    },
    {
      path: 'proveedores',
      name: 'dealers.enterprise.providers',
      component: page('enterprises/providers/index.vue'),
      props: true,
    },
    {
      path: 'proveedores/:id/editar',
      name: 'dealers.enterprise.providers.edit',
      component: page('enterprises/providers/create.vue'),
      props: true,
    },
    {
      path: 'proveedores/agregar',
      name: 'dealers.enterprise.providers.create',
      component: page('enterprises/providers/create.vue'),
      props: true,
    },
    {
      path: 'representaciones',
      name: 'dealers.enterprise.templates',
      component: page('enterprises/templates/index.vue'),
      props: true,
    },
    {
      path: 'representaciones/agregar',
      name: 'dealers.enterprise.templates.create',
      component: page('enterprises/templates/create.vue'),
      props: true,
    },
    {
      path: 'personalizacion-correo',
      name: 'dealers.enterprise.templates.subject',
      component: page('enterprises/templates-subject/index.vue'),
      props: true,
    },
    {
      path: 'personalizacion-correo/agregar',
      name: 'dealers.enterprise.templates.subject.create',
      component: page('enterprises/templates-subject/create.vue'),
      props: true,
    },
    {
      path: 'sftp',
      name: 'dealers.enterprise.sftp',
      component: page('enterprises/sftp/create.vue'),
      props: true,
    },
    {
      path: 'metodo-pago',
      name: 'dealers.enterprise.payment',
      component: page('enterprises/payment/index.vue'),
      props: true,
    },
    {
      path: 'metodo-pago/agregar',
      name: 'dealers.enterprise.payment.create',
      component: page('enterprises/payment/create.vue'),
      props: true,
    },
    {
      path: 'metodo-pago/:id/editar',
      name: 'dealers.enterprise.payment.edit',
      component: page('enterprises/payment/create.vue'),
      props: true,
    },
    {
      path: 'serie',
      name: 'dealers.enterprise.serie',
      component: page('enterprises/serie/index.vue'),
      props: true,
    },
    {
      path: 'serie/agregar',
      name: 'dealers.enterprise.serie.create',
      component: page('enterprises/serie/create.vue'),
      props: true,
    },
    {
      path: 'serie/:serieId/editar',
      name: 'dealers.enterprise.serie.edit',
      component: page('enterprises/serie/create.vue'),
      props: true,
    },
  ],
},
{
  path: '/catalogos/paquetes',
  name: 'services',
  component: page('catalogs/services/index.vue'),
  props: true,
},
{
  path: '/catalogos/paquetes/agregar',
  name: 'createServices',
  component: page('catalogs/services/create.vue'),
  props: true,
},
{
  path: '/catalogos/paquetes/:id',
  name: 'stockServices',
  component: page('catalogs/services/stock.vue'),
  props: true,
},
{
  path: '/catalogos/personalizacion-correo',
  name: 'templatesSubject',
  component: page('catalogs/templatesSubject/index.vue'),
  props: true,
},
{
  path: '/catalogos/personalizacion-correo/agregar',
  name: 'createTemplatesSubject',
  component: page('catalogs/templatesSubject/create.vue'),
  props: true,
},
{
  path: '/catalogos/personalizacion-correo/:id/editar',
  name: 'createTemplatesSubject.edit',
  component: page('catalogs/templatesSubject/edit.vue'),
  props: true,
},
{
  path: '/catalogos/personalizacion-correo/:detailItemId/detalle',
  name: 'templates.subject.detalle',
  component: page('catalogs/templatesSubject/detail.vue'),
  props: true,
},
{
  path: '/catalogos/actividad_comercial',
  name: 'commercialActivities',
  component: page('catalogs/commercialActivities/index.vue'),
  props: true,
},
{
  path: '/catalogos/actividad_comercial/:id/editar',
  name: 'createCommercialActivities.edit',
  component: page('catalogs/commercialActivities/create.vue'),
  props: true,
},
{
  path: '/catalogos/actividad_comercial/agregar',
  name: 'createCommercialActivities',
  component: page('catalogs/commercialActivities/create.vue'),
},
{
  path: '/catalogos/representaciones',
  name: 'templates',
  component: page('catalogs/templates/index.vue'),
  props: true,
},
{
  path: '/catalogos/representaciones/agregar',
  name: 'createTemplates',
  component: page('catalogs/templates/create.vue'),
  props: true,
},
{
  path: '/catalogos/representaciones/:detailItemId/detalle',
  name: 'templates.detalle',
  component: page('catalogs/templates/detail.vue'),
  props: true,
},
{
  path: '/catalogos/tipo_licencias',
  name: 'typeLicenses',
  component: page('catalogs/typeLicenses/index.vue'),
  props: true,
},
{
  path: '/catalogos/tipo_licencias/:id/editar',
  name: 'createtypeLicenses.edit',
  component: page('catalogs/typeLicenses/create.vue'),
  props: true,
},
{
  path: '/catalogos/tipo_licencias/agregar',
  name: 'createtypeLicenses',
  component: page('catalogs/typeLicenses/create.vue'),
},
{
  path: '/catalogos/proveedores_general',
  name: 'catalogs.providers',
  component: page('catalogs/providers/index.vue'),
  props: true,
},
{
  path: '/catalogos/proveedores_general/:id/editar',
  name: 'catalogs.providers.edit',
  component: page('catalogs/providers/create.vue'),
  props: true,
},
{
  path: '/catalogos/proveedores_general/agregar',
  name: 'catalogs.providers.create',
  component: page('catalogs/providers/create.vue'),
  props: true,
},
{
  path: '/catalogos/vendedores',
  name: 'catalogs.sellers',
  component: page('catalogs/sellers/index.vue'),
  props: true,
},
{
  path: '/catalogos/vendedores/:id/editar',
  name: 'catalogs.sellers.edit',
  component: page('catalogs/sellers/create.vue'),
  props: true,
},
{
  path: '/catalogos/vendedores/agregar',
  name: 'catalogs.sellers.create',
  component: page('catalogs/sellers/create.vue'),
  props: true,
},
{
  path: '/catalogos/planes',
  name: 'catalogs.plans',
  component: page('catalogs/plans/index.vue'),
  props: true,
},
{
  path: '/catalogos/planes/:id/editar',
  name: 'catalogs.plans.edit',
  component: page('catalogs/plans/create.vue'),
  props: true,
},
{
  path: '/catalogos/planes/agregar',
  name: 'catalogs.plans.create',
  component: page('catalogs/plans/create.vue'),
  props: true,
},
{
  path: '/dashboard/dashboard_documentos',
  name: 'dashboardInvoices',
  component: page('dashboard/invoices.vue'),
},
{
  path: '/dashboard/dashboard_envio_correo',
  name: 'dashboardTaskMail',
  component: page('dashboard/taskMail.vue'),
},
{
  path: '/dashboard/dashboard_descargas',
  name: 'dashboardDownload',
  component: page('dashboard/download.vue'),
},
{
  path: '/dashboard/dashboard_anulaciones',
  name: 'dashboardAnnulment',
  component: page('dashboard/annulment.vue'),
},
{
  path: '/empresas',
  name: 'enterprises',
  component: page('enterprises/list/index.vue'),
  props: true,
},
{
  path: '/empresas/agregar',
  name: 'enterprise.add',
  component: page('enterprises/list/create.vue'),
  props: true,
},
{
  path: '/empresas/:enterpriseId',
  component: page('enterprises/list/profile.vue'),
  props: true,
  children: [
    {
      path: '',
      redirect: {
        name: 'enterprise.profileEnterprise',
      },
    },
    {
      path: 'perfil',
      name: 'enterprise.profileEnterprise',
      component: page('enterprises/list/create.vue'),
      props: true,
    },
    {
      path: 'numeration',
      name: 'enterprise.numeration',
      component: page('enterprises/numeration/index.vue'),
      props: true,
    },
    {
      path: 'numeration/agregar',
      name: 'enterprise.numeration.create',
      component: page('enterprises/numeration/create.vue'),
      props: true,
    },
    {
      path: 'numeration/:serieId/editar',
      name: 'enterprise.numeration.edit',
      component: page('enterprises/numeration/create.vue'),
      props: true,
    },
    {
      path: 'numeration/:counterId/invoice',
      name: 'enterprise.numeration.invoice',
      component: page('enterprises/numeration/invoce.vue'),
      props: true,
    },
    {
      path: 'numeration/:counterId/invoice/:editedItem/create',
      name: 'enterprise.numeration.invoice.create',
      component: page('enterprises/numeration/invocecreate.vue'),
      props: true,
    },
    {
      path: 'numeration/autoregistro',
      name: 'enterprise.numeration.auto',
      component: page('enterprises/numeration/automatic.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll',
      name: 'enterprise.numeration_payroll',
      component: page('enterprises/numeration_payroll/index.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll/agregar',
      name: 'enterprise.numeration_payroll.create',
      component: page('enterprises/numeration_payroll/create.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll/:serieId/editar',
      name: 'enterprise.numeration_payroll.edit',
      component: page('enterprises/numeration_payroll/create.vue'),
      props: true,
    },
    {
      path: 'numeration_payroll/autoregistro',
      name: 'enterprise.numeration_payroll.auto',
      component: page('enterprises/numeration_payroll/automatic.vue'),
      props: true,
    },
    {
      path: 'usuarios',
      name: 'enterprise.users',
      component: page('enterprises/users/index.vue'),
      props: true,
    },
    {
      path: 'usuarios/agregar',
      name: 'enterprise.users.create',
      component: page('enterprises/users/create.vue'),
      props: true,
    },
    {
      path: 'usuarios/:id/:type/editar',
      name: 'enterprise.users.edit',
      component: page('enterprises/users/create.vue'),
      props: true,
    },
    {
      path: 'integracion',
      name: 'enterprise.integration',
      component: page('enterprises/integration/index.vue'),
      props: true,
    },
    {
      path: 'integracion/agregar',
      name: 'enterprise.integration.create',
      component: page('enterprises/integration/create.vue'),
      props: true,
    },
    {
      path: 'integracion/:id/editar',
      name: 'enterprise.integration.edit',
      component: page('enterprises/integration/create.vue'),
      props: true,
    },
    {
      path: 'server',
      name: 'enterprise.server',
      component: page('enterprises/server/index.vue'),
      props: true,
    },
    {
      path: 'server/agregar',
      name: 'enterprise.server.create',
      component: page('enterprises/server/create.vue'),
      props: true,
    },
    {
      path: 'server/:id/editar',
      name: 'enterprise.server.edit',
      component: page('enterprises/server/create.vue'),
      props: true,
    },
    {
      path: 'proveedores',
      name: 'enterprise.providers',
      component: page('enterprises/providers/index.vue'),
      props: true,
    },
    {
      path: 'proveedores/:id/editar',
      name: 'enterprise.providers.edit',
      component: page('enterprises/providers/create.vue'),
      props: true,
    },
    {
      path: 'proveedores/agregar',
      name: 'enterprise.providers.create',
      component: page('enterprises/providers/create.vue'),
      props: true,
    },
    {
      path: 'representaciones',
      name: 'enterprise.templates',
      component: page('enterprises/templates/index.vue'),
      props: true,
    },
    {
      path: 'representaciones/agregar',
      name: 'enterprise.templates.create',
      component: page('enterprises/templates/create.vue'),
      props: true,
    },
    {
      path: 'personalizacion-correo',
      name: 'enterprise.templates.subject',
      component: page('enterprises/templates-subject/index.vue'),
      props: true,
    },
    {
      path: 'personalizacion-correo/agregar',
      name: 'enterprise.templates.subject.create',
      component: page('enterprises/templates-subject/create.vue'),
      props: true,
    },
    {
      path: 'sftp',
      name: 'enterprise.sftp',
      component: page('enterprises/sftp/create.vue'),
      props: true,
    },
    {
      path: 'metodo-pago',
      name: 'enterprise.payment',
      component: page('enterprises/payment/index.vue'),
      props: true,
    },
    {
      path: 'metodo-pago/agregar',
      name: 'enterprise.payment.create',
      component: page('enterprises/payment/create.vue'),
      props: true,
    },
    {
      path: 'metodo-pago/:id/editar',
      name: 'enterprise.payment.edit',
      component: page('enterprises/payment/create.vue'),
      props: true,
    },
    {
      path: 'licencias',
      name: 'enterprise.licences',
      component: page('enterprises/licences/index.vue'),
      props: true,
    },
    {
      path: 'serie',
      name: 'enterprise.serie',
      component: page('enterprises/serie/index.vue'),
      props: true,
    },
    {
      path: 'serie/agregar',
      name: 'enterprise.serie.create',
      component: page('enterprises/serie/create.vue'),
      props: true,
    },
    {
      path: 'serie/:serieId/editar',
      name: 'enterprise.serie.edit',
      component: page('enterprises/serie/create.vue'),
      props: true,
    },
  ],
},
{
  path: '/documentos/lista_documentos',
  name: 'documents',
  component: page('documents/documents/index.vue'),
  props: true,
},
{
  path: '/documentos/lista_documentos/:enterprise_id/:serie?/:type/:document_number/correo',
  name: 'documents.email',
  component: page('documents/documents/history.vue'),
  props: true,
},
{
  path: '/documentos/lista_documentos/:enterprise_id/:serie?/:type/:document_number/sms',
  name: 'documents.sms',
  component: page('documents/documents/history_sms.vue'),
  props: true,
},
{
  path: '/documentos/asignaciones',
  name: 'assignments',
  component: page('documents/assignments/index.vue'),
},
{
  path: '/movimientos',
  name: 'transactions',
  component: page('transactions/index.vue'),
  props: true,
},
{
  path: '/auditoria/interna',
  name: 'binnacle',
  component: page('binnacle/index.vue'),
  props: true,
},
{
  path: '/auditoria/empresa',
  name: 'binnacle.enterprise',
  component: page('binnacle/enterprise.vue'),
  props: true,
},
{
  path: '/mantenimiento/roles',
  name: 'maintenance.roles',
  component: page('maintenance/roles/index.vue'),
  props: true,
},
{
  path: '/mantenimiento/roles/agregar',
  name: 'maintenance.roles.add',
  component: page('maintenance/roles/create.vue'),
  props: true,
},
{
  path: '/mantenimiento/roles/:roleId/editar',
  name: 'maintenance.roles.edit',
  component: page('maintenance/roles/create.vue'),
  props: true,
},
{
  path: '/mantenimiento/permisos',
  name: 'maintenance.permissions',
  component: page('maintenance/permissions/index.vue'),
  props: true,
},
{
  path: '/mantenimiento/permisos/agregar',
  name: 'maintenance.permissions.add',
  component: page('maintenance/permissions/create.vue'),
  props: true,
},
{
  path: '/mantenimiento/permisos/:permissionId/editar',
  name: 'maintenance.permissions.edit',
  component: page('maintenance/permissions/create.vue'),
  props: true,
},
{
  path: '/mantenimiento/notificaciones',
  name: 'maintenance.notification',
  component: page('maintenance/notification/index.vue'),
  props: true,
},
{
  path: '/mantenimiento/notificaciones/agregar',
  name: 'maintenance.notification.add',
  component: page('maintenance/notification/create.vue'),
  props: true,
},
{
  path: '/mantenimiento/notificaciones/:id/editar',
  name: 'maintenance.notification.edit',
  component: page('maintenance/notification/create.vue'),
  props: true,
},
{
  path: '/mantenimiento/mensaje',
  name: 'maintenance.message',
  component: page('maintenance/consultation/index.vue'),
},
{ path: '/otros/lotes', name: 'batches', component: page('others/batches/index.vue') },
{ path: '/reportes/libro', name: 'salebook.index', component: page('reports/salebook/generate.vue') },
{ path: '/reportes/libro/agregar', name: 'generate-salebook', component: page('reports/salebook/create.vue') },
{
  path: '/notificaciones',
  name: 'notification',
  component: page('notification/index.vue'),
  props: true,
},
{
  path: '/reportes/reportes_pagos',
  name: 'reportPayments',
  component: page('reports/payments/index.vue'),
  props: true,
},
{
  path: '/reportes/reportes_nominas',
  name: 'reportDocumentsPayroll',
  component: page('reports/payroll/index.vue'),
  props: true,
},
{
  path: '/reportes/transacciones',
  name: 'reportLicenses',
  component: page('reports/licences/index.vue'),
  props: true,
},
{
  path: '/documentos/lista_documentos_nomina',
  name: 'documents.payroll',
  component: page('documents/documents-payroll/index.vue'),
  props: true,
},
{
  path: '/documentos/lista_documentos_nomina/:enterprise_id/:serie?/:type/:number/correo',
  name: 'documents,payroll.email',
  component: page('documents/documents-payroll/history.vue'),
  props: true,
},
{
  path: '/documentos/lista_documentos_nomina/:enterprise_id/:serie?/:type/:number/sms',
  name: 'documents.payroll.sms',
  component: page('documents/documents-payroll/history_sms.vue'),
  props: true,
},
{
  path: '/planes-corporativos/cuentas',
  name: 'planes-corporativos.cuentas',
  component: page('corporate-plans/acounts/index.vue'),
},
{
  path: '/planes-corporativos/cuentas/:historyId/historial',
  name: 'planes-corporativos.account.historial',
  component: page('corporate-plans/acounts/history.vue'),
  props: true,
},
{
  path: '/planes-corporativos/reportes-cuentas',
  name: 'planes-corporativos.reportes-cuentas',
  component: page('corporate-plans/logs/index.vue'),
},
{
  path: '/reportes/reportes_devengado',
  name: 'reportRevenuePayroll',
  component: page('reports/payroll/revenue.vue'),
  props: true,
},
{
  path: '*',
  component: page('errors/404.vue'),
},
];
